import { useTranslation } from 'react-i18next'
import { RiCloseLine } from '@remixicon/react'
import { useAuth } from '../../contexts/AuthContext'
import { useAnnouncements } from '../../hooks/useAnnouncements'
import { cx, focusRing } from '../../lib/utils'
import { LEVEL_CLASSES } from './announcementStyles'

/**
 * The bar at the top of every shell: what an admin wants everyone to read.
 * Plain text only, and a closed one stays closed for that person.
 */
export default function AnnouncementBar() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { announcements, dismiss } = useAnnouncements(user?.id)

  if (announcements.length === 0) return null

  return (
    <div>
      {announcements.map((announcement) => (
        <div
          key={announcement.id}
          role={announcement.level === 'critical' ? 'alert' : 'status'}
          className={cx(
            'flex items-start justify-between gap-3 px-4 py-2.5 text-sm font-medium sm:px-6',
            LEVEL_CLASSES[announcement.level],
          )}
        >
          <p className="min-w-0 break-words">{announcement.message}</p>
          {announcement.dismissible && (
            <button
              type="button"
              onClick={() => dismiss(announcement.id)}
              aria-label={t('announcements.dismiss')}
              className={cx('-my-1 -mr-1 shrink-0 rounded p-1 opacity-80 hover:opacity-100', focusRing)}
            >
              <RiCloseLine className="size-5" aria-hidden="true" />
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
